import { Reveal, Kicker } from "./Reveal";
import { WHY_US } from "../../data/site";

export const WhyUs = () => {
    return (
        <section
            id="dece"
            data-testid="whyus-section"
            className="relative border-t border-white/10 bg-[#0a0a0a] py-24 text-white md:py-36"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-20">
                    <div className="lg:col-span-4">
                        <Reveal>
                            <Kicker>De ce să ne alegi</Kicker>
                        </Reveal>
                        <Reveal delay={0.05}>
                            <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
                                Patru motive <span className="text-gold">simple</span>
                            </h2>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <p className="mt-6 font-body text-neutral-400">
                                Nu facem doar tunsori. Creăm o experiență în jurul
                                fiecărui client.
                            </p>
                        </Reveal>
                    </div>

                    <div className="lg:col-span-8">
                        <div className="flex flex-col">
                            {WHY_US.map((item, i) => (
                                <Reveal
                                    key={item.title}
                                    delay={i * 0.06}
                                    data-testid={`whyus-item-${i}`}
                                    className="group grid grid-cols-1 gap-4 border-b border-white/10 py-8 first:pt-0 sm:grid-cols-12 sm:items-baseline"
                                >
                                    <div className="sm:col-span-1">
                                        <span className="font-display text-sm text-gold">
                                            0{i + 1}
                                        </span>
                                    </div>
                                    <h3 className="font-display text-2xl font-medium tracking-tight transition-transform duration-500 group-hover:translate-x-2 sm:col-span-5 md:text-3xl">
                                        {item.title}
                                    </h3>
                                    <p className="font-body text-neutral-400 sm:col-span-6">
                                        {item.desc}
                                    </p>
                                </Reveal>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
